module.exports = __webpack_public_path__ + "img/tb1041-10-1974.prt.c6b25159.jpg";